import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrls: ['./supplier.component.css']
})
export class SupplierComponent implements OnInit {

  parent_acct = '';
  acctList = [];
  catList = [];
  countryList = [];
  city = [];
  cityList = [];
  acctDetail = '';

  model = {
    'table_name': 'supplier', 'supplier_id': '0', 'supplier_name': '', 'supplier_name_en': '', 'acct_number': '',
    'supplier_category_id': '0', 'tax_no': '', 'city_id': '0', 'address': '', 'mobile': '', 'phone1': '',
    'phone2': '', 'fax': '', 'email': '', 'represent1': '', 'represent1_mobile': '', 'represent2': '',
    'key': 'supplier_id', 'flag': 'new', 'represent2_mobile': '', 'comment': '', 'is_account': '1',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'supplier_cr': ''
  };

  country_model = { 'country_id': '' };
  date_model = {
    'base_date': new Date(this.applicationConstants.business_cycle.start_date), 'base_type': 'creditor',
    'has_base': '0', 'for_all_branch': '0'
  };

  base_model = {
    'table_name': 'acct_base', 'baseline_id': '0', 'base_date': '', 'acct_number': '',
    'main_acct_no': this.applicationConstants.main_acct_config['supplier'],
    'acct_type_no': this.applicationConstants.acct_type_config['supplier'], 'key': 'baseline_id',
    'flag': 'new', 'baseline_amount': '0', 'comment': ''
  };

  sub_acct_model = {
    'table_name': 'sub_acct', 'sub_acct_id': '0',
    'acct_type_no': this.applicationConstants.acct_type_config['supplier'],
    'main_acct_no': this.applicationConstants.main_acct_config['supplier'], 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct': '', 'acct_level': '0', 'is_leaf': '1',
    'is_cc': '0', 'tax_acct': '0', 'emp_no': '0', 'cc_no': '0', 'key': 'sub_acct_id', 'flag': 'new',
    'comment': '', 'auto_set': '0', 'set_type': 'count'
  };

  Success_Msg; Error_Msg;
  Belong_To_Msg; Acct_No_Msg;
  Supplier_Name_Msg; Eng_Name_Msg;
  Category_Msg; Cont_City_Msg; Mobile_Msg;
  Acct_No_Exist;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<SupplierComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Belong_To_Msg').subscribe((res: string) => {
      this.Belong_To_Msg = res;
    });

    translate.get('Acct_No_Msg').subscribe((res: string) => {
      this.Acct_No_Msg = res;
    });

    translate.get('Supplier_Name_Msg').subscribe((res: string) => {
      this.Supplier_Name_Msg = res;
    });

    translate.get('Eng_Name_Msg').subscribe((res: string) => {
      this.Eng_Name_Msg = res;
    });

    translate.get('Category_Msg').subscribe((res: string) => {
      this.Category_Msg = res;
    });

    translate.get('Cont_City_Msg').subscribe((res: string) => {
      this.Cont_City_Msg = res;
    });

    translate.get('Mobile_Msg').subscribe((res: string) => {
      this.Mobile_Msg = res;
    });

    translate.get('Acct_No_Exist').subscribe((res: string) => {
      this.Acct_No_Exist = res;
    });
  }


  ngOnInit() {
    let obj;

    // get not leaf supplier accts
    this.parent_acct = this.applicationConstants.main_acct_config['supplier'];
    obj = { cmd: 'getAccountList', parent_acct: this.parent_acct, include_parent: true, add_leaf: false };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.acctList = data.data['list'];

        if (this.dialog_data == null) {
          if (this.acctList.length > 0) {
            this.parent_acct = this.acctList[0]['acct_number'];
            this.acctDetail = this.parent_acct + ' - ' + this.acctList[0]['sub_acct_name'] + ' - ' +
              this.acctList[0]['sub_acct_name_en'];
          }
          else
            this.acctDetail = this.parent_acct + ' - حسابات الموردين - Supplier Accounts';

          this.onChangeSearch("", this.parent_acct);
        }
      });

    let query = this.queryList.all_supplierCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.catList = data.data['list'];
      });

    query = this.queryList.all_country;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.countryList = data.data['list'];
      });

    query = this.queryList.all_city;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city = data.data['list'];
        if (this.dialog_data != null)
          this.getCity();
      });

    if (this.dialog_data != null) {
      // document.getElementById("base").style.display = 'none';
      this.model = this.dialog_data['0'];
      this.country_model = this.dialog_data['1'];
      this.date_model['for_all_branch'] = (this.model['branch_id'] == '0' ? '1' : '0');

      // if (this.model['is_account'] == '1')
      //   (document.getElementById('is_account') as HTMLInputElement).checked = true;
      // else {
      if (this.model['is_account'] != '1') {
        // check if it has base
        query = "SELECT * FROM `acct_base` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
        obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let result = data.data['list'];
            if (result.length > 0)
              this.date_model['has_base'] = '1';
          });
      }

      this.sub_acct_model['sub_acct_name'] = this.model['supplier_name'];
      this.sub_acct_model['sub_acct_name_en'] = this.model['supplier_name_en'];
      this.sub_acct_model['acct_number'] = this.model['acct_number'];
      this.sub_acct_model['tax_acct'] = this.model['tax_no'];
      this.sub_acct_model['comment'] = this.model['comment'];
      this.sub_acct_model['flag'] = 'update';

      // get sub acct
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            let sub_acct = data.data['list'][0];
            this.sub_acct_model['sub_acct_id'] = sub_acct['sub_acct_id'];
            this.sub_acct_model['parent_acct'] = sub_acct['parent_acct'];
            this.sub_acct_model['acct_level'] = sub_acct['acct_level'];
            this.sub_acct_model['is_leaf'] = sub_acct['is_leaf'];
            this.sub_acct_model['is_cc'] = sub_acct['is_cc'];

            if (this.sub_acct_model['is_cc'] == '1')
              this.date_model['has_base'] = '1';

            // get parent acct detail
            query = this.queryList.all_subAcct + " AND `acct_number` = '" + sub_acct['parent_acct'] + "'";
            obj = { cmd: 'getList', query: query };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let parent_acct = data.data['list'][0];
                this.acctDetail = sub_acct['parent_acct'] + ' - ' + parent_acct['sub_acct_name'] + ' - ' +
                  parent_acct['sub_acct_name_en'];
                console.log(parent_acct);
                // console.log((document.getElementById('parent_acct') as HTMLInputElement));
                // (document.getElementById('search_value_0') as HTMLInputElement).value = sub_acct['parent_acct'] + ' - ' +
                //   parent_acct['sub_acct_name'] + ' - ' + parent_acct['sub_acct_name_en'];
              });
          }
        });
    }
  }

  onChangeSearch = function (acct_number: string, parent_acct: string) {
    console.log(acct_number);

    if (acct_number != '' || parent_acct != '') {
      this.sub_acct_model['parent_acct'] = "";

      if (acct_number != '')
        this.sub_acct_model['parent_acct'] = acct_number;
      else if (parent_acct != '')
        this.sub_acct_model['parent_acct'] = parent_acct;

      if (this.model['supplier_id'] == '0') {
        this.model['acct_number'] = "";
        this.sub_acct_model['acct_level'] = "0";

        // if (this.sub_acct_model['parent_acct'] != "") {
        var element;
        for (let index = 0; index < this.acctList.length; index++) {
          element = this.acctList[index];
          if (element.acct_number == this.sub_acct_model['parent_acct']) {
            this.sub_acct_model['acct_level'] = String(Number(element.acct_level) + 1);
            break;
          }
        }
        if (this.sub_acct_model['acct_level'] == "0")
          this.sub_acct_model['acct_level'] = String(Number(this.sub_acct_model['acct_level']) + 1);

        let query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" +
          this.sub_acct_model['parent_acct'] + "'";
        let obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let result = data.data['list'][0]['acct_number'];
            if (result == '0')
              this.model['acct_number'] = this.sub_acct_model['parent_acct'] + "001";
              else {
                if (result.indexOf(this.sub_acct_model['parent_acct']) != -1) {
                  result = result.substring(result.indexOf(this.sub_acct_model['parent_acct']) + (this.sub_acct_model['parent_acct']).length);
                  console.log('result: ' + result);
                  result = String(Number(result) + 1);
                  if (Number(result) < 10)
                    result = '00' + result;
                  else if (Number(result) < 100)
                    result = '0' + result;
                    
                  this.model['acct_number'] = this.sub_acct_model['parent_acct'] + result;
                }
                else
                  this.model['acct_number'] = String(Number(result) + 1);
              }
          });
        // }
      }

    }
  }

  changeAcctNumber() {
    if (this.model['acct_number'] == "" && this.sub_acct_model['parent_acct'] != "")
      this.onChangeSearch("", this.sub_acct_model['parent_acct']);
  }

  getCity() {
    this.cityList = [];
    this.city.forEach(element => {
      if (element.country_id == this.country_model['country_id'])
        this.cityList.push(element);
    });
  }

  changeIsAccount() {
    this.model['is_account'] = ((document.getElementById('is_account') as HTMLInputElement).checked ? '1' : '0');
    if (this.model['supplier_id'] == '0' && this.model['is_account'] == '0')
      this.onChangeSearch("", this.parent_acct);
  }

  changeForAllBranch() {
    this.date_model['for_all_branch'] = ((document.getElementById('for_all_branch') as HTMLInputElement).checked ? '1' : '0');
    this.model['branch_id'] = (this.date_model['for_all_branch'] == '1' ? '0' : this.applicationConstants.user_branch_info.user_branch_id);
  }

  add() {
    if (this.model['is_account'] == '1' && this.sub_acct_model['parent_acct'] == '') {
      alert(this.Belong_To_Msg);
      return;
    }

    if (this.model['acct_number'] == '') {
      alert(this.Acct_No_Msg);
      return;
    }

    if (this.model['supplier_name'] == '') {
      alert(this.Supplier_Name_Msg);
      return;
    }

    if (this.model['supplier_name_en'] == '') {
      alert(this.Eng_Name_Msg);
      return;
    }

    // if (this.model['supplier_category_id'] == '0') {
    //   alert(this.Category_Msg);
    //   return;
    // }

    // if (this.model['city_id'] == '0') {
    //   alert(this.Cont_City_Msg);
    //   return;
    // }

    if (this.model['mobile'] == '') {
      alert(this.Mobile_Msg);
      return;
    }

    let values = [];
    values.push(this.model);

    //add sub acct
    this.sub_acct_model['sub_acct_name'] = this.model['supplier_name'];
    this.sub_acct_model['sub_acct_name_en'] = this.model['supplier_name_en'];
    this.sub_acct_model['acct_number'] = this.model['acct_number'];
    this.sub_acct_model['is_cc'] = this.model['is_account'];
    this.sub_acct_model['tax_acct'] = this.model['tax_no'];
    this.sub_acct_model['comment'] = this.model['comment'];

    values.push(this.sub_acct_model);

    //add acct base if supplier is account
    if (this.model['is_account'] == '1' && this.date_model['has_base'] == '0') {

      //add acct base
      this.base_model['base_date'] = this.date_model['base_date'].getFullYear() + '-' +
        (this.date_model['base_date'].getMonth() + 1) + '-' + this.date_model['base_date'].getDate() +
        " 00:00:00";
      // ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();

      this.base_model['acct_number'] = this.model['acct_number'];
      if (this.date_model['base_type'] == 'creditor' && this.base_model['baseline_amount'] != '0')
        this.base_model['baseline_amount'] = '-' + this.base_model['baseline_amount'];

      values.push(this.base_model);
    }

    let obj;
    if (this.model['supplier_id'] == '0') {
      let query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          let result = data.data['list'];
          if (result.length > 0)
            alert(this.Acct_No_Exist);
          else {
            // save supplier
            obj = { cmd: 'add', values: values };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success') {
                  alert(this.Success_Msg);
                  this.dialog_data = { 'op_type': 'success' };
                  this.dialogRef.close(this.dialog_data);
                }
                else
                  alert(this.Error_Msg);

              });
          }
        });
    }
    else {
      // update supplier
      obj = { cmd: 'updateAdv', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else
            alert(this.Error_Msg);

        });
    }


    // if (this.model['supplier_id'] == '0') {
    //   let prefix = '401' + this.model.city_id;
    //   obj = { cmd: 'add', values: values, pk: 'acct_number', id: 'supplier_id', main_table: 'supplier', prefix: prefix };
    // }
    // else {
    //   let values1 = [];
    //   values1.push(this.model);

    //   //if the supplier is account:
    //   if (this.model['is_account'] == '1') {
    //     values1.push(this.sub_acct_model);
    //   }
    //   // obj = { cmd: 'update', values: values1, where: where };
    //   obj = { cmd: 'updateAdv', values: values1 };
    // }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }


}
